import codeSplit from 'scripts/higher-order-components/codeSplit'
import l10n from './l10n'

export default codeSplit({
  l10n,
  loadComponent: () =>
    import(
      /* webpackChunkName: "ContactSweden" */
      './data'
    ),
})
